module.exports = __webpack_public_path__ + "static/media/3.243b3113.png";